export let augustUppercase = "nJJ_Ne";
export default {augustUppercase};